<template>
  <div class="pkg-content" v-loading="dataListLoading">
    <el-row>
      <el-col :span="24" align="right">
        <el-button type="primary" @click="handleSave"
          >{{ $t("save") }}
        </el-button>
        <el-button type="primary" @click="handleBack"
          >{{ $t("返回") }}
        </el-button>
      </el-col>
    </el-row>
    <div class="divider" />

    <div>
      <el-form
        label-position="top"
        :inline="true"
        :model="dataForm"
        ref="dataForm"
        :rules="rules"
      >
        <div class="opten-title">
          <em class="el-icon-caret-right"></em>平账信息
        </div>
        <el-row class="row-mar-l">
          <el-col :span="6"  v-show="isShow">
            <!-- 平账编号 -->
            <el-form-item label="平账编号" prop="balanceAccountNo">
              <el-input
                v-model="dataForm.balanceAccountNo"
                placeholder="自动生成"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6"  v-show="isShow">
            <!-- 平账类别 -->
            <el-form-item label="平账类别">
              <span slot="label">平账类别
                <el-tooltip placement="top-start" effect="dark">
                  <div slot="content">
                    <div>价格变更：在手工平账管理中创建的平账单</div>
                    <div>培训状态修改：在修改已有平账记录的培训记录状态时创建的平帐单</div>
                  </div>
                  <img
                          style="width: 14px; height: 14px"
                          src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                          alt=""
                  />
                </el-tooltip>
              </span>
              <el-select
                v-model="dataForm.balanceAccountType"
                clearable
                placeholder="请选择"
                :disabled="true"
              >
                <el-option
                  v-for="item in balanceAccountTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
           <el-col :span="6">
            <!-- 平账标题 -->
            <el-form-item label="平账标题" prop="balanceAccountTitle">
              <el-input
                v-model="dataForm.balanceAccountTitle"
                placeholder="请输入平账标题"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 单条培训记录平账金额 -->
            <el-form-item
              prop="amountType"
            >
            <span slot="label">单条培训记录平账金额
                <el-tooltip placement="top-start" effect="dark">
                  <div slot="content">
                    <p>平账金额表示单条培训记录平账的金额</p>
                    <p>补缴：表示填入的金额需要结算时经销商补缴</p>
                    <p>退款：表示填入的金额将退回给结算时经销商</p>
                  </div>
                  <img
                          style="width: 14px; height: 14px"
                          src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                          alt=""
                  />
                </el-tooltip>
              </span>
              <el-select
                v-model="dataForm.amountType"
                clearable
                style="width: 40% !important"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>

              <currency-input
                v-model="dataForm.singleAmount"
                :min="0"
                :max="99999999.99"
                :precision="2"
                style="width: 59% !important"

              ></currency-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">

          <el-col :span="12">
            <!--  平账凭证 -->
            <el-form-item label="平账凭证" prop="fileList" style="width: 90% !important">
              <el-upload
                class="upload-demo"
                ref="upload"
                :show-file-list="true"
                :headers="myHeader"
                :action="uploadUrl"
                :on-change="uploadChange"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
                :file-list="dataForm.fileList"
                :auto-upload="true"
              >
                <div style="text-align: left;">
                  <el-button
                    slot="trigger"
                    type="primary"
                  >
                    请选择上传的文件
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="单个文件不能超过20MB"
                      placement="top"
                    >
                      <em style="color: #fff" class="el-icon-question"></em>
                    </el-tooltip>
                  </el-button>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <el-col :span="24" style="text-align: center">
            <el-form-item
              label="平账说明"
              prop="balanceDes"
              style="width: 95% !important"
            >
              <el-input
                v-model="dataForm.balanceDes"
                type="textarea"
                placeholder="请输入平账说明"
                rows="5"
                maxlength="1000"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="opten-title" style="margin-top: 30px">
        <em class="el-icon-caret-right"></em>平账培训记录
      </div>
      <el-row v-show="getStatus()" class="row-mar-l" style="text-align: center">
        <el-col :span="24">
          <div class="button_item">
              <el-button  type="primary" @click="deleteDatas"
              >{{ $t("offering.listDelete") }}
              </el-button>
            <el-button type="primary" @click="handleTrainingRecord"> 添加培训记录 </el-button>
            <el-button type="primary" @click="handleDownload"
              >模板下载
            </el-button>
            <el-button type="primary" @click="handleImport"
              >导入
              <el-tooltip
                class="item"
                effect="dark"
                content="导入只支持Excel格式文件，最大10M"
                placement="top"
              >
                <em style="color: #fff" class="el-icon-question"></em>
              </el-tooltip>
            </el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: center">
          <el-table
            ref="multipleTable"
            :data="tablePagingData"
            border
            :row-style="{ height: 48 + 'px' }"
            :cell-style="{ padding: 0 + 'px' }"
            class="table_item"
            @selection-change="handleSelectionChange"
          >
          <el-table-column
          header-align="center"
          align="center"
          type="selection"
          width="55"
          v-if="getStatus()">
          </el-table-column>
            <!-- 培训记录编号 -->
            <el-table-column
              prop="trainingKey"
              label="培训记录编号"
              header-align="center"
              align="center"
              min-width="280px"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 用户ID -->
            <el-table-column
              prop="userCode"
              label="用户ID"
              header-align="center"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 用户姓名 -->
            <el-table-column
              prop="userNameCn"
              label="用户姓名"
              header-align="center"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 课程代码 -->
            <el-table-column
              prop="courseCode"
              label="课程代码"
              header-align="center"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 课程名称 -->
            <el-table-column
              prop="courseName"
              label="课程名称"
              header-align="center"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 排期编号 -->
            <el-table-column
              prop="offeringNo"
              label="排期编号"
              header-align="center"
              align="center"
              min-width="120"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 排期开始时间 -->
            <el-table-column
              prop="offeringStartDate"
              label="排期开始时间"
              header-align="center"
              align="center"
              min-width="140"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 排期结束时间 -->
            <el-table-column
              prop="offeringEndDate"
              label="排期结束时间"
              header-align="center"
              align="center"
              min-width="140"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 报名时排期价格 -->
            <el-table-column
              prop="offeringPrice"
              label="报名时排期价格（元）"
              header-align="center"
              align="right"
              min-width="165"
              :show-overflow-tooltip="true"
            >
            <template slot-scope="scope">
             {{ scope.row.offeringPrice | formatMoney }}
            </template>
            </el-table-column>
            <!-- 合计结算费用（元） -->
            <el-table-column
              label="合计结算费用（元）"
              header-align="center"
              align="right"
              min-width="160"
            >
              <template slot-scope="scope">
                <el-popover
                  placement="top-start"
                  width="400px"
                  trigger="click">
                  <el-row>
                    <el-col :span="24" style="height: 44px; margin: auto; text-align: center; font-weight: 700; font-size: 14px; background-color: #F2F2F2;">
                      <p>结算费用明细</p>
                    </el-col>
                  </el-row>
                  <el-table :data="gridData" v-loading="gridLoading"   style="width: 460" :cell-style="cellStyle">
                    <el-table-column header-align="center" width="220" label="摘要" align="center" show-overflow-tooltip prop="detail"></el-table-column>
                    <el-table-column header-align="center" width="105" label="结算费用" align="right" prop="billingPrice">
                      <template slot-scope="scope">
                        {{scope.row.billingPrice | formatMoney}}
                      </template>
                    </el-table-column>
                    <el-table-column header-align="center" min-width="135" label="平账编号" align="center" show-overflow-tooltip prop="balanceAccountNo"></el-table-column>
                  </el-table>
                  <!-- <el-link type="primary" :underline="false" slot="reference">{{scope.row.settlementFeesTotal}}</el-link> -->
                  <span slot="reference" @click="loadData(scope.row)" style="color: #409eff; cursor: pointer;">{{scope.row.countPrice | formatMoney}}</span>
                </el-popover>
              </template>
            </el-table-column>
            <!-- 报名时经销商 -->
            <el-table-column
              prop="orgNameCn"
              label="报名时经销商"
              header-align="center"
              align="center"
              min-width="160"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 结算时经销商 -->
            <el-table-column
              prop="orgParentNameCn"
              label="结算时经销商"
              header-align="center"
              align="center"
              min-width="160"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <!-- 培训记录状态 -->
            <el-table-column
              prop="trainingStatus"
              label="培训记录状态"
              header-align="center"
              align="center"
              min-width="160"
              :show-overflow-tooltip="true"
              :formatter="format"
            ></el-table-column>
            <!-- 发票号 -->
            <el-table-column
              prop="invoiceNumber"
              label="发票号"
              header-align="center"
              align="center"
              min-width="180"
              :show-overflow-tooltip="true"
            ></el-table-column>
          </el-table>
          <el-pagination
            :current-page="tablePaging.pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="tablePaging.pageSize"
            :total="dataForm.trainingRecordList.length"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="pageSizeChangeHandle"
            @current-change="pageCurrentChangeHandle"
          >
          </el-pagination>
        </el-col>
      </el-row>
    </div>
    <import-excel
      v-bind:visible="isShowImportDialog"
      v-bind:url="importExcelUrl"
      v-on:closeDialogImport="isShowImportDialog = false"
      @importData="importData"
    ></import-excel>
    <training-record
      v-if="trainingDialog"
      ref="trainingRecord"
      :selectedData="dataForm.trainingRecordList"
      @receiveData="refreshTrainingData"></training-record>

    <el-dialog  :visible.sync="dialogVisible" :close-on-click-modal="true" :modal="true" :show-close="true" :center="true">
        <el-row>
          <el-col :span="24" style="height: 44px; margin: auto; text-align: center; font-weight: 700; font-size: 14px;">
            <p>平账金额导致以下培训记录合计结算费用出现负值，请重新填写</p>
          </el-col>
        </el-row>
        <el-table :data="errorData" v-loading="gridLoading"  style="width: 100%" :cell-style="cellStyle">
          <el-table-column min-width="40%" label="培训记录编号" header-align="center" align="center" show-overflow-tooltip prop="trainingKey"></el-table-column>
          <el-table-column min-width="20%" label="用户ID" header-align="center" align="center" show-overflow-tooltip prop="userCode"></el-table-column>
          <el-table-column min-width="20%" label="用户姓名" header-align="center" align="center" show-overflow-tooltip prop="userName"></el-table-column>
          <el-table-column min-width="20%" label="合计结算费用" header-align="center" align="center" prop="price">
            <template slot-scope="scope">
              {{scope.row.price | rounding}}
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog  :visible.sync="dialogVisible1" :close-on-click-modal="true" :modal="true" :show-close="true" :center="true">
        <el-row>
          <el-col :span="24" style="height: 44px; margin: auto; text-align: center; font-weight: 700; font-size: 14px;">
            <p>以下培训记录正在处理结算账户，暂时不可修改平账单，请明日再试</p>
          </el-col>
        </el-row>
        <el-table :data="errorData" v-loading="gridLoading"  style="width: 100%" :cell-style="cellStyle">
          <el-table-column min-width="40%" label="培训记录编号" header-align="center" align="center" show-overflow-tooltip prop="trainingKey"></el-table-column>
          <!-- <el-table-column min-width="20%" label="用户ID" header-align="center" align="center" show-overflow-tooltip prop="userCode"></el-table-column>
          <el-table-column min-width="20%" label="用户姓名" header-align="center" align="center" show-overflow-tooltip prop="userName"></el-table-column>
          <el-table-column min-width="20%" label="合计结算费用" header-align="center" align="center" prop="price">
            <template slot-scope="scope">
              {{scope.row.price | rounding}}
            </template>
          </el-table-column>                     -->
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible1 = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible1 = false">确 定</el-button>
        </span>
    </el-dialog>
  </div>

</template>

<script>
import importExcel from "./components/import";
import currencyInput from './components/currency-input';
import trainingRecord from "./components/training-record";
import indexVue from '../../../../components/rm/user-select/index.vue';
//import mixinViewModule from "@/mixins/view-module";

export default {
    components: {
      importExcel,
      currencyInput,
      trainingRecord,
    },
 // mixins: [mixinViewModule],
  data() {
    let _this = this;
    const validateFiles = (rule, value, callback) => {
      let files = this.$refs['upload'].uploadFiles;
      if (!files.length) {
        callback(new Error('请选择上传的文件'));
      }
      callback();
    };
    return {
      dialogVisible: false,
      dialogVisible1:false,
      trainingDialog:false,
      mixinViewModuleOptions: {
        getBillingDetailsUrl: '/learning/account/getBillingDetails',
        getDetail: '/learning/account/getHandDetail',
      },
      isShow: false,
      dataListLoading: false,
      statusList: [
        { label: "补缴", value: "10" },
        { label: "退款", value: "20" }
      ],
      balanceAccountTypeList: [
        { label: "价格变更", value: "10" },
        { label: "培训状态修改", value: "20" }
      ],
      dataForm: {
        id: "",
        sourceId: "",
        balanceAccountNo: "",
        balanceAccountTitle: "",
        amountType: "",
        balanceAccountType: "",
        singleAmount: "",
        balanceDes: "",
        fileList: [],
        trainingRecordList: [],
      },
      rules: {
        balanceAccountTitle: [{ required: true, message: "请输入内容" }],
        amountType: [
          {
            required: true,
            message: "请选择平账类型",
            trigger: "change",
          },
        ],
        fileList: [{ required: true, validator: validateFiles }],
      },
      uploadUrl: "/learning/account/picupload",
      myHeader: { token: "" },
      url: "/learning/account/picupload",
      tablePaging: {
        pageNum: 1,
        pageSize: 10,
        data: [],
      },
      isShowImportDialog: false,
      importExcelUrl: "/learning/account/import",
      saveUrl: "/learning/account/saveAccount",
      deleteUrl: "/learning/account/picDelete",
      deletesUrl: "/learning/account/picDeletes",
      gridLoading: false,
      gridData: [],
      errorData: [],
      multipleSelection: []
    };
  },
  // 计算属性
  computed: {
    // 表格分页
    tablePagingData() {
      let start = (this.tablePaging.pageNum - 1) * this.tablePaging.pageSize;
      let end = this.tablePaging.pageNum * this.tablePaging.pageSize;
      return this.dataForm.trainingRecordList.slice(start, end);
    },
  },
  watch: {},
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    this.$eventHub.$on('handwork_balance_account', (data) => {
      if (this.$refs.dataForm) {
        this.$refs['dataForm'].resetFields();
        this.initial();
      }
    })
  },
  destroyed() {
    //this.unloadHandler(this.dataForm.fileList)
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.initial();
  },
  activated() {
    console.log('activated')
  },
  filters: {
    rounding (value) {
      if (value == null) {
        return null
      } else {
        return value.toFixed(2)
      }
    },
     formatMoney(num) {
      if (!num && num !== 0 && num !== '0') {
        return ''
      }
      num = num.toString().replace(/\$|\,/g, '')
      if (isNaN(num)) {
        num = '0'
      }
      let sign = num == (num = Math.abs(num))
      num = Math.floor(num * 100 + 0.50000000001)
      let cents = num % 100
      num = Math.floor(num / 100).toString()
      if (cents < 10) {
        cents = '0' + cents
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3))
      }
      return (sign ? '' : '-') + num + '.' + cents
    }
  },
  methods: {
    isShowDelete(){
      if(this.dataForm.id != null && this.dataForm.balanceAccountType === '20'){
        return false
      } else {
        return true
      }
    },
     // 删除多条
    deleteDatas(row){
      console.log("选中的数据:"+ this.dataForm.trainingRecordList)
      console.log("已勾选的培训记录:"+this.multipleSelection)

      if(this.multipleSelection.length <= 0){
        this.$message({
                    message: '请选择要删除的数据',
                    type: 'warning',
                    duration: 1500,
                  })
      } else {
            for (let i in this.multipleSelection) {
              this.dataForm.trainingRecordList.splice(this.dataForm.trainingRecordList.indexOf(this.multipleSelection[i]), 1)
            }
      }

    },
    //多选框
    handleSelectionChange(val) {
      this.multipleSelection = val;
      },
     formatMoney(num) {
      if (!num && num !== 0 && num !== '0') {
        return ''
      }
      num = num.toString().replace(/\$|\,/g, '')
      if (isNaN(num)) {
        num = '0'
      }
      let sign = num == (num = Math.abs(num))
      num = Math.floor(num * 100 + 0.50000000001)
      let cents = num % 100
      num = Math.floor(num / 100).toString()
      if (cents < 10) {
        cents = '0' + cents
      }
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3))
      }
      return (sign ? '' : '-') + num + '.' + cents
    },
    initial() {
      this.isShow = false;
      this.uploadUrl = `${window.SITE_CONFIG["apiURL"]}` + this.url;
      this.myHeader.token = this.getStorage(this.GLOBAL.TOKEN);
      if (this.$route.query.id !== undefined && this.$route.query.id !== null && this.$route.query.id !== '') {
        this.isShow = true;
        this.dataForm.id = this.$route.query.id;
        this.dataForm = this.$route.query.data;
        this.dataListLoading = true
        this.$request.get(
                this.mixinViewModuleOptions.getDetail,
                {
                  'balanceAccountNo': this.dataForm.balanceAccountNo
                }
        ).then((res, total, code, data) => {
          this.dataForm.trainingRecordList = data.data
          this.dataListLoading = false
        }).catch(() => {
          this.dataListLoading = false
        })
        this.dataForm.amountType = this.$route.query.data.amountType
        this.getDetail();
      } else {
        this.dataForm.singleAmount = 0.00
        this.dataForm.trainingRecordList = []
      }
    },
    format(row,column){
      if(row.trainingStatus === "10"){
        return "待审批"
      } else if(row.trainingStatus === "20"){
        return "已报名"
      } else if(row.trainingStatus === "30"){
        return "已拒绝"
      } else if(row.trainingStatus === "40"){
        return "已撤销"
      } else if(row.trainingStatus === "50"){
        return "等待中"
      } else if(row.trainingStatus === "60"){
        return "缺勤"
      } else if(row.trainingStatus === "70"){
        return "已完成"
      } else if(row.trainingStatus === "80"){
        return "未通过"
      } else if(row.trainingStatus === "90"){
        return "进行中"
      }
    },
    handleSave() {

      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.tablePagingData.length === 0) {
            return this.$message({
              message: "请导入需平账培训记录",
              type: "error",
              duration: 2000,
            });
          } else {
            this.dataListLoading = true,
          // 提交数据
          this.dataForm.sourceId='10'
          this.dataForm.id = this.$route.query.id
            this.$request.post(
            this.saveUrl,
            this.dataForm
          ).then((res, total, code, data) => {
            console.log(data)
            this.dataListLoading = false
            // this.dataListLoading = false
            // this.dataList = data.data.records
            // this.total = this.mixinViewModuleOptions.getDataListIsPage ? parseInt(data.data.total, 10) : 0
            // // 延迟加载
            // this.$nextTick(() => {
            //   this.querSelect()
            // })
            if(data.code == 1) {
              if (data.msg != 'success') {
                if (data.msg == "平账金额导致以下培训记录合计结算费用出现负值，请重新填写") {
                //  this.$confirm(data.data, data.msg, {
                //      dangerouslyUseHTMLString: true,
                //      confirmButtonText: this.$t('confirm'),
                //     cancelButtonText: this.$t('cancel')
                //   }).then(() => {

                //   }).catch(() => {
                //     this.loading = false
                //   })
                this.dialogVisible = true
                this.errorData = data.data.accountErrorDTOS
                } else if (data.msg == "以下培训记录正在处理结算账户，暂时不可修改平账单，请明日再试") {
                this.dialogVisible1 = true
                this.errorData = data.data.accountErrorDTOS
                } else {
                  return this.$message.error(data.msg)
                }
              } else {
                this.tabRemove(this.$store.state.contentTabsActiveName);
                this.$message({
                    message: '保存成功',
                    type: 'success',
                    duration: 1500,
                  })
                }
              }
          }).catch(() => {
            this.dataListLoading = false
          })
          }
        }
      });
    },
    getStatus() {
      if(this.$route.query.id != null && this.dataForm.balanceAccountType == 20){
          return false;
      } else {
        return true;
      }
    },
     tabRemove(tabName) {
      if (tabName === "home") {
        return false;
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => item.name !== tabName
      );
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName =
          "home";
        return false;
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          path: "/manage/charge-handworkBalanceAccount-index",
        });
      }
    },
    handleBack() {
      this.$router.push({
        path: "/manage/charge-handworkBalanceAccount-index",
        params: {},
      });
    },
    handleTrainingRecord(){
      this.trainingDialog = true
      this.$nextTick(() => {
        this.$refs['trainingRecord'].initial()
      })
    },
    handleDownload() {
      // 替换成模板下载正确内容
       let url = '/learning/account/templateDownload'
      // let fileName = '手工平账培训记录导入模板'
      // let resourceFileName = '手工平账培训记录导入模板.xlsx'
      //this.$request.download(url, fileName, {fileName: resourceFileName})
      this.$request.downloadITM(url, '手工平账培训记录导入模板')
    },
    handleImport() {
      this.isShowImportDialog = true
    },
    importData(data) {
      if (data.data.handworkAccountTrainingHistoryDTOS != null) {
        this.$message({
          message: "导入成功",
          type: "SUCCESS",
          duration: 1500,
        });
        //var arry = ([this.dataForm.trainingRecordList])
        for(let item of data.data.handworkAccountTrainingHistoryDTOS) {
		      this.dataForm.trainingRecordList.push(item)
        }
        console.log(this.dataForm.trainingRecordList)
        var arry= this.unique(this.dataForm.trainingRecordList)
        console.log(arry)
        this.dataForm.trainingRecordList = arry
      }
    },
    unique(arr) { // 根据唯一标识no来对数组进行过滤
　　const res = new Map();  //定义常量 res,值为一个Map对象实例
　　//返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
　　return arr.filter((arr) => !res.has(arr.trainingKey) && res.set(arr.trainingKey, 1))
    },
    uploadChange(file, fileList) {
      if (fileList.length && fileList.length > 0) {
        this.$refs['dataForm'].validateField('fileList');
      }
    },
    handlePreview(file) {
      console.log(file)
      if (this.dataForm.fileList === '' || this.dataForm.fileList === null || this.dataForm.fileList === undefined) {
        this.$message({
          message: '请先上传文件',
          type: 'error',
          duration: 1500,
        })
      } else {
        this.$message({
          message: this.$t('user.authApplyDownloadFileMessage'),
          type: 'info',
          duration: 1000,
        })
        this.$request.downloadBigFile('/learning/account/picDownload',
        // this.$request.download('/sys/commAdminFileManagement/downloadFile',
          file.name,
          {
            url: file.url,
            name: file.name
          },
          null,
          false
        )
      }
    },
    handleRemove(file, fileList) {
      if (file && file.status === "success") {
        if (this.$route.query.id != undefined) {
          // 1.获取将要删除图片的临时路径
          let filePath = file.response ? file.response.data.tmp_path : file.url
          // 2.从pics数组中，找到图片对应的索引值
          let i = this.dataForm.fileList.findIndex(x => x.url === filePath)
          // 3.调用splice方法，移除图片信息
          this.dataForm.fileList.splice(i, 1)
        } else {
          this.$request.post(
                  this.deleteUrl,
                  file
          ).then((res, total, code, data) => {
            if (data.code == 1) {
              // 1.获取将要删除图片的临时路径
              let filePath = file.response ? file.response.data.tmp_path : file.url
              // 2.从pics数组中，找到图片对应的索引值
              let i = this.dataForm.fileList.findIndex(x => x.url === filePath)
              // 3.调用splice方法，移除图片信息
              this.dataForm.fileList.splice(i, 1)
            }
          }).catch(() => {
            this.dataListLoading = false
          })
        }
      }
    },
    unloadHandler(e) {
      if (e.length > 0) {
        for(let item of e)  {
            this.$request.post(
              this.deleteUrl,
              item
            ).then((res, total, code, data) => {
              console.log(res)
            }).catch(() => {
              this.dataListLoading = false
            })
         };

      }
    },
    // 上传成功
    handleSuccess(response, file, fileList) {
      if (response.code === 200) {
        let id = file.uid
        // 2.从pics数组中，找到图片对应的索引值
        let i = fileList.findIndex(x => x.uid === id)
        // 3.调用splice方法，移除图片信息
        fileList.splice(i, 1)
        this.$message({
          message: response.msg,
          type: "error",
          duration: 1500,
        });
      } else {
        this.dataForm.fileList.push({
          name: response.data.certificateName,
          url: response.data.certificatePath,
          id: response.data.certificateId
        })
        file.name = response.data.certificateName
        file.url = response.data.certificatePath
        file.id = response.data.certificateId
        if (response.code !== 1) {
          this.handleRemove(file, this.dataForm.fileList)
          this.$message({
            message: response.msg,
            type: "error",
            duration: 1500,
          });
        } else {
          this.$message({
            message: "上传成功",
            type: "success",
            duration: 1500,
          });
        }
    }
    },
    beforeUpload(file, fileList) {
      if (file == null) {
        this.$message({
          message: "请先上传文件",
          type: "error",
          duration: 1500,
          // onClose: () => {
          //     this.getDataList()
          // }
        });
        return false;
      }
      if (/.+\.exe$/.test(file.name)) {
          this.$message({
          message: "禁止上载exe文件",
          type: "error",
          duration: 1500
        });
        return false;
      }
      let maxLength = 20 * 1024 * 1024;
      if (file.size > maxLength) {
        this.$message({
          message: "文件大小不能超过20M",
          type: "error",
          duration: 1500,
        });
        return false;
      }
      return true;
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.tablePaging.pageNum = 1;
      this.tablePaging.pageSize = val;
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.tablePaging.pageNum = val;
    },
    getDetail(){
      console.log('getDetail')
    },
    refreshTrainingData(val) {
      this.dataForm.trainingRecordList = val.data
    },
    loadData(row) {
        // 清空gridData数据
      // 设置加载状态
      console.log(row)
      this.$request.post(
        this.mixinViewModuleOptions.getBillingDetailsUrl,
        {
          trainingKey: row.trainingKey
        }
      ).then((res, total, code, data) => {
        this.dataListLoading = false
        this.gridData = data.data
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? parseInt(data.data.total, 10) : 0
        // 延迟加载
        this.$nextTick(() => {
          this.querSelect()
        })
      }).catch(() => {
        this.dataListLoading = false
      })
      this.gridLoading = true
      // 调用后端获取数据赋值给gridData
      //this.gridData = []
      // 取消加载状态
      this.gridLoading = false

    },
    cellStyle({row, rowIndex}) {
      return 'border-right: initial !important; padding: 4px 0;'
    }
  },
};
</script>

<style rel="stylesheet/scss" scoped lang="scss">
@import "../../../css/pkg-styles.css";
.divider {
  display: block;
  height: 2px;
  width: 100%;
  margin: 24px 0;
  background-color: #a2a2a2;
  position: relative;
}
.fl-input.is-disabled  .el-input__inner {
  color: blue !important;
  text-decoration: underline;
  cursor: pointer;
}
.button_item, .table_item {
  text-align: left;
  margin-bottom: 7px !important;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
  width: 95% !important;
}
.el-col-12 {
  text-align: center;
}
.el-select.el-select--default  .el-input.el-input--default.el-input--suffix input{
   height: 34px !important;
   margin-right: 2px !important;
 }
 .el-input.el-input--default {
   float: right;
 }
  .el-dialog__footer {
   height: 40px !important;
 }
</style>
